import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import getWhatsAppData from './chat';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import Loader from '../components/loader';

function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
}

function App() {

    const [loader, setLoader] = useState(false);
    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");
    const userType = sessionStorage.getItem("TRCUserType");
    const [whatsAppData, setWhatsAppData] = useState([]);
    const [chatScreen, setChatScreen] = useState(null);
    const [messages, setMessages] = useState('');
    const messagesEndRef = useRef(null);

    const { width, height } = useWindowSize();

    const fetchWhatsAppData = () => {
        getWhatsAppData().then(res => {
                setWhatsAppData(res);
        }).catch(err => {
            console.error("Error fetching WhatsApp data:", err);
        });
    };

    useEffect(() => {
        fetchWhatsAppData();
        const interval = setInterval(() => {
            fetchWhatsAppData();
        }, 3000); 
        return () => clearInterval(interval);
    }, []);

    const openChat = (e) => {
        const phoneNumber = e;
        setChatScreen(phoneNumber);
        const timeout = setTimeout(() => {
            scrollToBottom();
        }, 500);
        return () => clearTimeout(timeout);
    };

    console.log("WhatsApp Data:", whatsAppData);

    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    const sendMsg = async () => {
        const sendData = {
            type: 'text',
            user: userID,
            phone: chatScreen,
            msg: messages,
        }

        try {

            const response = await axios.post("https://api.trucoo.in/whatsapp/sent/", sendData, {
                 headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
            });

            console.log("Message sent successfully:", response.data);
        } catch (error) {
            console.error("Error sending message:", error);
        }
        setMessages('');
        fetchWhatsAppData();

        const timeout = setTimeout(() => {
            scrollToBottom();
        }, 500);
        return () => clearTimeout(timeout);
    };

return (
    <>
    {loader && <Loader /> }
    <Header />
    <Sidebar />

    <div class="content-wrapper" style={{maxHeight: "calc(100vh - 80px)", minHeight: "calc(100vh - 80px)"}}>
	
			<section class="content">

			    <div class="box">
                    {/* <div class="box-header with-border">
				        <h4 class="box-title"><i class="fa fa-whatsapp fs-20"></i> WhatsApp</h4>
				        <p class="mb-0 box-subtitle">Ref ID : </p>
                        <p class="mb-0 box-subtitle">Date : </p>
                        <p class="mb-0 box-title"></p>
				    </div> */}
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-5" style={{maxHeight: "calc(100vh - 180px)",  overflowY: "scroll"}}>
                                {/* <p class="mb-0 box-title">Chat</p> */}
                                {Object.entries(whatsAppData).map(([phoneNumber, messages]) => {
                                    const lastMessage = messages[0];
                                    const lastMessageWithName = messages.find(msg => msg.name?.trim());

                                    return (
                                        <div key={phoneNumber} 
                                            className="card" 
                                            onClick={() => openChat(phoneNumber)} 
                                            data-phone-number={phoneNumber} 
                                            style={{ 
                                                cursor: "pointer", 
                                                backgroundColor: chatScreen === phoneNumber ? "#a3e6d1ff" : "#fff" 
                                            }}>
                                            <div className="card-body">
                                                <p className="text-bold">
                                                    {lastMessageWithName?.name}<br />
                                                    <small className="fs-10">+{phoneNumber}</small>
                                                </p>
                                                <div className="bg-light p-2" style={{ borderRadius: "5px" }}>
                                                    <p className="card-text bg-light" style={{ marginLeft: "20px" }}>
                                                        {lastMessage.bodyType === "text" ? (
                                                            lastMessage.body
                                                        ) : (
                                                            <span>
                                                                <i class="fa fa-image"></i> {lastMessage.bodyType.toUpperCase()}
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                                <p className="card-text text-end">
                                                    <small className="text-muted fs-10">{lastMessage.time}</small>
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                                
                            </div>

                            

                            <div class="col-md-7" style={{maxHeight: "calc(100vh - 180px)", minHeight: "calc(100vh - 180px)", overflowY: "scroll"}}>
                                 {chatScreen ? (
                                    <>
                                    <table class="table" style={{ top:'0', position: "relative"}}>
                                        {whatsAppData[chatScreen] && whatsAppData[chatScreen].length > 0 ? (
                                            [...whatsAppData[chatScreen]].reverse().map((message, index) => (
                                            <>
                                                <tr key={index}>
                                                    <td  style={{justifyContent: message.type === 'out' ? "flex-end" : 'flex-start', display: "flex"}}>
                                                        <div className={`mt-2 ${message.type === 'out' ? "bg-secondary" : "bg-light"}`} style={{borderRadius: "5px", width: message.bodyType === 'text' ? "85%" : "60%", padding: "10px 20px"}}>
                                                            {message.bodyType === "text" ? (
                                                                message.body
                                                            ) : message.bodyType === "image" ? (
                                                                   <div style={{ display: "flex", justifyContent: "center", marginTop: "20px"  }}>
                                                                        <img
                                                                        src={`https://api.trucoo.in/uploads/media/${message.file}`}
                                                                        alt="Media"
                                                                        style={{ maxWidth: "90%", borderRadius: "20px" }}
                                                                        />
                                                                        <a href={`https://api.trucoo.in/uploads/media/${message.file}`} target="_blank" rel="noopener noreferrer" style={{float: 'right', marginLeft: "20px", fontSize: "20px"}} ><i class="fa fa-download"></i></a>
                                                                    </div>
                                                                ) : message.bodyType === "video" ? (
                                                                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                                                        <video controls style={{ maxWidth: "90%", borderRadius: "5px" }}>
                                                                        <source
                                                                            src={`https://api.trucoo.in/uploads/media/${message.file}`}
                                                                            type="video/mp4"
                                                                        />
                                                                        Your browser does not support the video tag.
                                                                        </video>
                                                                        <a href={`https://api.trucoo.in/uploads/media/${message.file}`} target="_blank" rel="noopener noreferrer" style={{float: 'right', marginLeft: "20px", fontSize: "20px"}} ><i class="fa fa-download"></i></a>
                                                                    </div>
                                                                ) : message.bodyType === "document" ? (
                                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                                        <a href={`https://api.trucoo.in/uploads/media/${message.file}`} target="_blank" rel="noopener noreferrer" className="fs-12 text-decoration-none">
                                                                            <i className="fa fa-file-text-o" aria-hidden="true"></i> {message.mediaName || message.mediaType}
                                                                        </a>
                                                                        <a href={`https://api.trucoo.in/uploads/media/${message.file}`} target="_blank" rel="noopener noreferrer" style={{float: 'right', marginLeft: "20px", fontSize: "20px"}} ><i class="fa fa-download"></i></a>
                                                                    </div>
                                                                    ) : (
                                                                        <span>
                                                                            [{message.bodyType.toUpperCase()}]{" "}
                                                                            {message.mediaName || message.mediaType}
                                                                        </span>
                                                                    )

                                                                }
                                                            
                                                            <div className="text-end">
                                                                <span className="text-muted fs-10">{message.time} {message?.userName?.length > 0 &&  `| Sent By ${message.userName}`}</span>
                                                            </div>
                                                        </div>
                                                         
                                                    </td>
                                                </tr>
                                               
                                            </>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center text-muted">No messages found</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>
                                                <div ref={messagesEndRef} style={{minHeight: "110px"}} />
                                            </td>
                                        </tr>
                                    </table>
                                    <div style={{position: "absolute", bottom: "0", right: '0', left: width > 768 ? '42%' : '0', width: width > 768 ? "58%" : "100%", backgroundColor: "#fff", padding: "10px", }}>
                                        <textarea class="form-control" rows="3" value={messages} onChange={(e) => setMessages(e.target.value)}></textarea>
                                        <div class="justify-content-end d-flex">
                                            <button class="btn btn-success mt-2" onClick={sendMsg}> <i class="fa fa-paper-plane" aria-hidden="true"></i> Send</button>
                                        </div>
                                    </div>
                                </>
                                ) : (
                                    <div className="text-center justify-content-center align-items-center d-flex flex-column" style={{ height: "100%"}}>
                                        <h5 className="text-muted">Select a chat to view messages</h5>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    
    </>
);
}

export default App;
